export interface CaptchaOutputModel {
  captchaCode?: string;
  id?: string;
  image?: any;
}

export interface UserProfileOutputModel {
  birthday?: string;
  email?: string;
  expiresIn?: number;
  firstName?: string;
  iban?: string;
  id?: number;
  lastName?: string;
  nationalCode?: string;
  refreshToken?: string;
  token?: string;
  userAccountId?: number;
  username?: string;
}

export interface SettingDataOutputModel {
  agencyName?: string;
  logo?: string;
  slogan?: any;
  description?: string;
  mobileAppPicture?: any;
  ruleLink?: any;
  cancellationRuleLink?: any;
  blogLink?: any;
  aboutUsLink?: any;
  contactUsLink?: any;
  supportTel?: string;
  supportMobile?: string;
  address?: string;
  mapLatitude?: number;
  mapLongitude?: number;
  mapZoom?: any;
  email?: string;
  nemad?: any;
  socialMedia?: any;
  pageTitle?: string;
  metaDescription?: string;
  domainName?: string;
  footerDescription?: string;
  brandName?: any;
  themeColor?: any;
  agencyId?: number | any;
  terminalCode?: any;
  whiteLabelId?: any;
  defaultLanguageId?: number;
  bannerEnableFlag?: number;
  campaignEnableFlag?: number;
  hotelTypeEnableFlag?: number;
  topDestinationEnableFlag?: number;
  exchangeRateEnableFlag?: number;
  hotelUrl?: string;
  hotelId?: number;
  imageId?: any;
  languageId?: any;
  cityRoute?: any;
  registerMethodTypeName?: string;
  registerMethodTypeId?: number;
  loginMethodTypeName?: string;
  type: any;
  loginMethodType?: string;
  paymentDescription?: string;
  paymentTypeId?: any;
  terminalGroupId?: any;
  reserveKindList?: any[];
  baseUrl?: string;
}

export class CurrentUser {
  id?: number;
  expiresIn?: number;
  token?: string;
  refreshToken?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  nationalCode?: string;
  userAccountId?: any;
  birthday?: any;
  email?: any;
  iban?: any;
  whiteLabelId?: number;
}

export interface HotelInfoOutPutModel {
  hotelId?: number;
  hotelName?: string;
  hotelTypeName?: string;
  cityId?: number;
  provinceId?: number;
  starCount?: number;
  description?: string;
  guestRank?: any;
  hotelAddress?: string;
  picturePath?: any;
  pictureAlt?: string;
  pictureTitle?: string;
  boardPrice?: any;
  offerPrice?: any;
  hotelUrl?: string;
  imageId?: string;
  latitude?: number;
  longitude?: number;
  foodServiceTypeId?: any;
  foodServiceTypeName?: any;
  pictureName?: string;
  reserveDisableFlag?: boolean;
  maxDiscount?: any;
  moneyTypeName?: any;
  exchangePrice?: any;
  moneySymbol?: string;
  offerMoneySymbol?: string;
  boardExchangePrice?: any;
  boardMoneyTypeName?: any;
  offerExchangePrice?: any;
  offerMoneyTypeName?: any;
  navigated?: any;
}

export interface gridProviderServiceOutputModel {
  result?: any;
  messages?: any[];
}
